<template>
<tr
    :class="{ 'is-selected': isSelected}"
    @click="selectFile(file)"
    @dblclick="insertFile(file)"
>
    <td class="file-row-file-icon">
            <span class="icon">
        <i
            v-if="isLoading"
            aria-hidden="true"
            class="fas fa-spinner fa-spin"
        ></i>
        <img
            v-else-if="isImage"
            :src="previewUrl"
        />
        <i
            v-else
            aria-hidden="true"
            class="fas fa-file"
        ></i>
        </span>
    </td>
    <td
        class="file-row-file-name"
        :title="file.name"
    >

        {{ file.name }}
    </td>
    <td
        :title="authorTitle"
        class="file-row-file-author"
    >
        {{ file.author }}
    </td>
    <td
        class="file-row-file-size"
        :title="fileSize"
    >
        {{ fileSize }}
    </td>
    <td>
        <label class="checkbox is-flex is-justify-content-center file-toggle-is-public">
            <input type="checkbox" v-model="file.is_public" @click.stop="togglePublic">
        </label>
    </td>
</tr>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
    name: "BaseFileRow",
    props: {
        file: Object,
    },
    computed: {
        ...mapState('fileManagement', [
            'trans',
            'actions',
            'selectedFile',
            'deletingFile',
            'renamingFile',
            'isInsertMode',
        ]),
        ...mapState('editor', ['editor']),
        isSelected() {
            return this.selectedFile.hash_id === this.file.hash_id;
        },
        isDeleting() {
            return this.deletingFile.hash_id === this.file.hash_id;
        },
        isRenaming() {
            return this.renamingFile.hash_id === this.file.hash_id;
        },
        isLoading() {
            return this.isDeleting || this.isRenaming;
        },
        fileSize() {
            return this._humanFileSize(this.file.size, this.trans.size_measures)
        },
        authorTitle() {
            return `${this.file.author} (${this.file.email})`;
        },
        previewUrl() {
            return this.getFileUrl(this.file);
        },
        isImage() {
            return this.isImageFile(this.file);
        },
    },
    methods: {
        ...mapActions('fileManagement', [
            'selectFile',
            'hideFileManagementModal',
            'toggleIsPublic',
            'showFileSetIsPublicModal',
        ]),

        /**
         * Вставка файла в редактор
         */
        insertFile(file) {
            if (!this.isInsertMode) {
                return;
            }

            let {content, selector} = this.getFileHtml(file);

            this.editor.insertContent(content);
            this.hideFileManagementModal();

            this.editor.selection.select(this.editor.dom.select(selector).pop());
        },
        togglePublic(event) {
            this.showFileSetIsPublicModal(this.file);
            event.preventDefault();
        }
    }
}
</script>

<style lang="scss" scoped>
@import 'resources/sass/variables';
tr {
    transition: all 0.5s ease;
    word-break: break-word;

    td {
        vertical-align: middle!important;
    }

    i {
        color: #aaa9a9;
    }

    &:hover {
        background-color: #f9f9f9;
        cursor: pointer;
    }

    &.is-selected {
        background-color: #e6edfc !important;
        color: #186bdd !important;
    }

    .file-row-file-icon {
        span {
            vertical-align: middle;

            img {
                max-height: 100%;
            }
        }
    }
    .file-row-file-name {
        word-break: break-all;
        width: 50%;
    }
    .file-row-file-author {
        width: 30%;
    }

    .file-row-file-size {
        width: 20%;
    }

    .file-toggle-is-public {
        input {
            height: 1rem;
            width: 1rem;
        }
    }
}
</style>